import axios from 'axios';
import { modal } from '../modal-template/modal-template';
const DATA_ATTR = 'data-account-cabinet-groups';
const CLASS_PREFIX = 'account-cabinet-groups';


export function initPersonalAccountGroups($container) {

    const $templateMain = document.querySelector(`[${DATA_ATTR}-template-main]`);
    const $templateEmpty = document.querySelector(`[${DATA_ATTR}-template-empty]`);
    const $templateCard = document.querySelector(`[${DATA_ATTR}-template-card]`);
    const $templateCardNew = document.querySelector(`[${DATA_ATTR}-template-card-new]`);
    const $templateList = document.querySelector(`[${DATA_ATTR}-template-list]`);

    let $componentContainer = null;
    let $groupCount = null
    let $contentContainer = null
    let $loader = null

    let currentSkip = 0;
    let currentTake = 50;
    let totalCount = 0;
    let isEmpty = true;

    init();

    async function init() {
        if (!$templateMain) return;
        await renderMain();
        fetchGroups();
        // подписываемся на событие создания группы
        document.addEventListener('account-groups:created', handleGroupCreated);
    }

    function fetchGroups() {
        $loader.style.display = 'flex';
        axios.get('/api/groups', {
            params: {skip: currentSkip, take: currentTake}
        })
            .then(function (response) {
                const {data, meta} = response.data;
                if (!data || !data.length) {
                    renderEmpty();
                    $loader.style.display = 'none';
                    return;
                }

                const total = (meta && typeof meta.total !== 'undefined') ? meta.total : data.length;
                totalCount = total;
                renderList(data, total);
                $loader.style.display = 'none';
                //currentSkip += currentTake;
            })
            .catch(function (error) {
                console.error(error);
                renderEmpty();
            });
    }

    function renderMain(){
        const $mainFragment = $templateMain.content.cloneNode(true);

        $componentContainer = $mainFragment.querySelector(`[${DATA_ATTR}]`);
        $groupCount = $componentContainer.querySelector(`[${DATA_ATTR}-group-count]`);
        $contentContainer = $componentContainer.querySelector(`[${DATA_ATTR}-content]`);
        $loader = $componentContainer.querySelector(`[${DATA_ATTR}-loader]`);

        $container.appendChild($mainFragment);
        document.dispatchEvent(new CustomEvent('account-cabinet:render-complete', {bubbles: true}));
    }

    function renderEmpty() {
        if ($groupCount) $groupCount.textContent = '';
        $contentContainer.innerHTML = '';
        const emptyFragment = $templateEmpty.content.cloneNode(true);
        $contentContainer.appendChild(emptyFragment);
        isEmpty = true;
    }

    function renderList(groups, count) {
        $contentContainer.innerHTML = '';
        if ($groupCount) $groupCount.textContent = String(count);

        const listFragment = $templateList.content.cloneNode(true);
        const $listContainer = listFragment.querySelector(`[${DATA_ATTR}-list]`);
        const target = $listContainer || $contentContainer;

        const $cardNewFragment = $templateCardNew.content.cloneNode(true);
        $listContainer.appendChild($cardNewFragment);

        groups.forEach(group => {
            renderCard(target, group);
        });

        if ($listContainer) {
            $contentContainer.appendChild(listFragment);
        }
        isEmpty = false;
    }

    function renderCard($cardList, group) {
        const cardFragment = $templateCard.content.cloneNode(true);

        const $title = cardFragment.querySelector(`[${DATA_ATTR}-group-title]`);
        const $count = cardFragment.querySelector(`[${DATA_ATTR}-group-count]`);
        const $btnGroupInfo = cardFragment.querySelector(`[${DATA_ATTR}-btn-group-info]`);
        const $btnCopyReferal = cardFragment.querySelector(`[${DATA_ATTR}-btn-copy-referal]`);
        const $studentChar1 = cardFragment.querySelector(`[${DATA_ATTR}-student-1]`);
        const $studentChar2 = cardFragment.querySelector(`[${DATA_ATTR}-student-2]`);
        const $studentPlusCount = cardFragment.querySelector(`[${DATA_ATTR}-student-count]`);
        const $cardNode = cardFragment.firstElementChild;
        const referalLink = document.location.origin + '/join/' + group.referral_code;

        $btnCopyReferal.addEventListener('click', (e) => {
            e.preventDefault();
            modal.open('copy-referal', { modalReferral: referalLink });
        });

        if ($title) $title.textContent = group.name || 'Без названия';
        if ($count) {
            const students = (typeof group.students_count !== 'undefined') ? group.students_count : 0;
            $count.textContent = `${students} ${pluralizeStudents(students)}`;
        }
        if ($cardNode) {
            if ($btnGroupInfo) {
                $btnGroupInfo.addEventListener('click', (e) => {
                    e.preventDefault();
                    // диспатчим глобальное событие — account-cabinet его подхватит
                    document.dispatchEvent(new CustomEvent('account-cabinet:open', {
                        detail: { name: 'group-info', payload: { groupId: group.id } }
                    }));
                });
            }
        }

        // --- NEW: отображение первых двух студентов и "+N ещё" ---
        const preview = Array.isArray(group.students_preview) ? group.students_preview : [];

        // Первый символ
        if ($studentChar1) {
            const ch = preview[0] && preview[0].first_char ? preview[0].first_char : '';
            $studentChar1.textContent = ch;
            $studentChar1.style.display = ch ? '' : '';
        }

        // Второй символ
        if ($studentChar2) {
            const ch = preview[1] && preview[1].first_char ? preview[1].first_char : '';
            $studentChar2.textContent = ch;
            $studentChar2.style.display = ch ? '' : 'none';
        }

        // Плейсхолдер "+N ещё" — по запросу: не считаем первых двух
        const remaining = (typeof group.remaining_students_count !== 'undefined')
            ? Number(group.remaining_students_count)
            : Math.max(0, (Number(group.students_count) || 0) - 2);

        if ($studentPlusCount) {
            if (remaining > 0) {
                // Показываем в формате "+N ещё" (можно изменить текст)
                $studentPlusCount.textContent = `+${remaining}`;
                $studentPlusCount.style.display = '';
            } else {
                $studentPlusCount.textContent = '';
                $studentPlusCount.style.display = 'none';
                $studentPlusCount.title = '';
            }
        }
        // --- END NEW ---


        $cardList.appendChild(cardFragment);
    }

    function pluralizeStudents(n) {
        n = Number(n) || 0;
        if (n % 10 === 1 && n % 100 !== 11) return 'студент';
        if (n % 10 >= 2 && n % 10 <= 4 && !(n % 100 >= 12 && n % 100 <= 14)) return 'студента';
        return 'студентов';
    }

    // --- обработчик события создания новой группы ---
    function handleGroupCreated(e) {
        fetchGroups();
    }
}
